import http from 'plugins/axios'
const base = '/ta/admin/tenant/abnormalAsset'
export default {
  page(data) { return http.get({ url: `${base}/page`, data }) },
  available(data) { return http.get({ url: `${base}/available`, data }) },
  detail(data) { return http.get({ url: `${base}/detail`, data }) },
  handle(data) {
    const query = Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
    return http.post({ url: `${base}/handle?${query}` })
  },
  deduct(data) {
    const query = Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
    return http.post({ url: `${base}/deduct?${query}` })
  },
}
